import Component from "../abstracts/Component";
import ajaxAction from "../utils/ajaxUtil";
import TrackingComponent from "../components/TrackingComponent";
import { addOrUpdateUrlParam } from "../utils/SearchUrlUtil";
import {
  addNewPageInHistory,
  getFocusElement,
  hasFocusElement
} from "../utils/BrowserHistoryUtils";
import {
  removeTrapFocusOnModal,
  trapFocusOnModal,
  getFocusableElements
} from "../utils/TrapFocus";

export default class FiltersComponent extends Component {
  get SELECTORS() {
    return {
      filterWrapper: "[data-filter-wrapper]",
      closeMenu: "[data-menu-close]",
      triggerMenu: "[data-menu-trigger]",
      filter: "[data-filter]",
      checkboxFilter: "[data-checkbox-filter]",
      radioFilter: "[data-radio-filter]",
      dropdown: "[data-filter-dropdown]",
      benefitBar: "[data-benefit-bar]",
      listingHead: "[data-listing-head]",
      listingSearch: "[data-listing-search]",
      listingSearchInput: "[data-listing-search] input",
      resetSearchButton: "[data-reset-search]",
      gridSm: "[data-grid-sm]",
      gridMd: "[data-grid-md]",
      gridMaxSm: "[data-grid-max-sm]",
      gridMaxMd: "[data-grid-max-md]",
      gridMinSm: "[data-grid-min-sm]",
      gridMinMd: "[data-grid-min-md]",
      productTwinText: ".w-prod-twin-text",
      listing: ".c-listing",
      filterBar: "[data-filter-bar]",
      resetCta: "[data-cta-reset]",
      applyCta: "[data-cta-apply]",
      input: '.w-f__bar__filters input[type="checkbox"]',
      mobileInput: '.w-f__menu input[type="checkbox"]',
      mobileRadio: '.w-f__menu input[type="radio"]',
      sortBy: "[data-sortby]",
      productsContainer: "[data-products-container]",
      filtersResults: "[data-filter-results]",
      resultsCount: "[data-result-count]",
      productCard: ".c-product-card",
      resultsCounter: ".search-page-heading h2",
      filtersForm: "[data-filters-form]",
      menuMobile: "[data-menu-mobile]",
      menuMobileTitle: "[data-menu-mobile-title]",
      shortcutsList: "[data-shortcuts-list]",
      shortcutsCta: "[data-shortcuts-cta]",
      pageSalesFilters: "[data-page-sales]"
    };
  }

  get CLASSNAMES() {
    return {
      open: "open",
      fixed: "fixed",
      pttWide: "wide",
      active: "active"
    };
  }

  constructor(compEl) {
    super(compEl);
    this.body = document.querySelector("body");
    this.menuMobile = this.$component.querySelector(this.SELECTORS.menuMobile);
    this.menuMobileTitle = this.$component.querySelector(
      this.SELECTORS.menuMobileTitle
    );
    this.closeMenu = this.$component.querySelector(this.SELECTORS.closeMenu);
    this.triggerMenu = this.$component.querySelector(
      this.SELECTORS.triggerMenu
    );
    this.filterBar = this.$component.querySelector(this.SELECTORS.filterBar);
    this.filters = this.$component.querySelectorAll(this.SELECTORS.filter);
    this.checkboxFilters = this.$component.querySelectorAll(
      this.SELECTORS.checkboxFilter
    );
    this.radioFilters = this.$component.querySelectorAll(
      this.SELECTORS.radioFilter
    );
    this.resetCta = this.$component.querySelectorAll(this.SELECTORS.resetCta);
    this.applyCta = this.$component.querySelector(this.SELECTORS.applyCta);
    this.dropdowns = this.$component.querySelectorAll(this.SELECTORS.dropdown);
    this.listingHead = document.querySelector(this.SELECTORS.listingHead);
    if (!this.listingHead) {
      this.listingHead = document.querySelector(this.SELECTORS.listingSearch);
    }
    this.benefitBar = document.querySelector(this.SELECTORS.benefitBar);
    this.listing = document.querySelector(this.SELECTORS.listing);
    this.listings = document.querySelectorAll(this.SELECTORS.listing);
    this.listingSearchInput = document.querySelector(
      this.SELECTORS.listingSearchInput
    );
    this.resetSearchButton = document.querySelector(
      this.SELECTORS.resetSearchButton
    );
    this.productTwinText = document.querySelector(
      this.SELECTORS.productTwinText
    );
    this.gridSm = this.$component.querySelectorAll(this.SELECTORS.gridSm);
    this.gridMd = this.$component.querySelectorAll(this.SELECTORS.gridMd);
    this.inputs = this.$component.querySelectorAll(this.SELECTORS.input);
    this.mobileInputs = this.$component.querySelectorAll(
      this.SELECTORS.mobileInput
    );
    this.mobileRadios = this.$component.querySelectorAll(
      this.SELECTORS.mobileRadio
    );
    this.shortcutsList = this.$component.querySelector(
      this.SELECTORS.shortcutsList
    );
    this.shortcutsCta = this.$component.querySelector(
      this.SELECTORS.shortcutsCta
    );
    this.qs = new URLSearchParams(window.location.search);
    this.sortBy = this.$component.querySelectorAll(this.SELECTORS.sortBy);
    this.productsContainer = document.querySelector(
      this.SELECTORS.productsContainer
    );
    this.resultsCount = document.querySelector(this.SELECTORS.resultsCount);
    this.filtersForm = document.querySelector(this.SELECTORS.filtersForm);
    this.filterWrapper = document.querySelector(this.SELECTORS.filterWrapper);
    this.pageSalesFilters = document.querySelector(
      this.SELECTORS.pageSalesFilters
    );
    this.TrackingComponent = new TrackingComponent();
    this.ajaxAction = new ajaxAction();
    this.trapFocusHandler = () => {};
    this.trapFocusMobileFiltersHandler = () => {};
    this.classObserver = null;
  }

  listenScroll() {
    if (this.listingHead) {
      window.addEventListener("scroll", () => {
        if (window.scrollY > this.returnOffsetHeight(this.benefitBar)) {
          let value = (100 - window.scrollY) / 100;
          let opacity = value > 0 ? value : 0;
          this.listingHead.style.opacity = opacity;
        } else {
          this.listingHead.style.opacity = 1;
        }
        this.fixFilters();
      });
    }
  }

  listenGrid() {
    this.gridSm.forEach(grid => {
      grid.addEventListener("click", e => {
        this.setGridSmEvent(e.target);
      });
    });
    this.gridMd.forEach(grid => {
      grid.addEventListener("click", e => {
        this.setGridMdEvent(e.target);
      });
    });
  }

  listenDropdown() {
    this.dropdowns.forEach(dropdown => {
      dropdown.addEventListener("click", e => {
        e.stopPropagation();
      });
    });
    this.filters.forEach(filter => {
      filter.addEventListener("click", () => this.dropdownHandler(filter));
    });
    document.addEventListener("click", e => {
      this.filters.forEach(filter => {
        let arrow = filter.querySelector(".down");
        let trigger = filter.querySelector(".filter-dropdown-trigger");
        if (e.target !== filter && e.target !== arrow && e.target !== trigger) {
          this.closeDropdown(filter);
        }
      });
    });
  }

  dropdownHandler(selectedFilter) {
    let activeFilter = this.$component.querySelector("[data-filter].open");
    if (activeFilter) {
      this.closeDropdown(activeFilter);
      if (selectedFilter !== activeFilter) {
        this.openDropdown(selectedFilter);
      }
    } else {
      this.openDropdown(selectedFilter);
    }
  }

  openDropdown(filter) {
    const trigger = filter.querySelector(".filter-dropdown-trigger");
    const dropdown = filter.querySelector("[data-filter-dropdown]");
    this.trapFocusHandler = trapFocusOnModal(dropdown);
    trigger && trigger.setAttribute("aria-expanded", "true");
    dropdown && dropdown.setAttribute("aria-hidden", "false");
    filter.classList.add(this.CLASSNAMES.open);
  }

  closeDropdown(filter) {
    const dropdown = filter.querySelector("[data-filter-dropdown]");
    const trigger = filter.querySelector(".filter-dropdown-trigger");
    removeTrapFocusOnModal(dropdown, this.trapFocusHandler);
    trigger && trigger.setAttribute("aria-expanded", "false");
    dropdown && dropdown.setAttribute("aria-hidden", "true");
    filter.classList.remove(this.CLASSNAMES.open);
  }

  /**
   * Osserva i cambiamenti della classe dell'elemento menuMobile per gestire il focus accessibile
   */
  observeMenuMobileClass() {
    const ctx = this;

    // Disconnetti observer precedente se esiste
    if (this.classObserver) {
      this.classObserver.disconnect();
    }

    // Configura il MutationObserver
    this.classObserver = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          const target = mutation.target;

          // Controlla se la classe 'open' è stata aggiunta
          if (target.classList.contains(ctx.CLASSNAMES.open)) {
            ctx.toggleMenuMobileInputsTabindex(true);
            // Piccolo delay per assicurarsi che l'elemento sia visibile
            setTimeout(() => {
              const firstFocusableEl = getFocusableElements(ctx.menuMobile)[0];
              firstFocusableEl && firstFocusableEl.focus();
            }, 50);
          } else {
            ctx.toggleMenuMobileInputsTabindex(false);
          }
        }
      });
    });

    // Inizia a osservare i cambiamenti di attributi
    this.classObserver.observe(this.menuMobile, {
      attributes: true,
      attributeFilter: ["class"] // Osserva solo i cambiamenti della classe
    });
  }

  toggleMenuMobileInputsTabindex(isOpen) {
    this.mobileInputs.forEach(input => {
      input.setAttribute("tabindex", isOpen ? "0" : "-1");
    });
    this.mobileRadios.forEach(radio => {
      radio.setAttribute("tabindex", isOpen ? "0" : "-1");
    });
  }

  listenModal() {
    let scrollY;
    const ctx = this;
    if (this.triggerMenu != null && this.triggerMenu != "undefined") {
      this.triggerMenu.addEventListener("click", () => {
        ctx.trapFocusMobileFiltersHandler = trapFocusOnModal(ctx.menuMobile);
        ctx.menuMobile.classList.add(ctx.CLASSNAMES.open);
        ctx.triggerMenu.setAttribute("aria-expanded", "true");
        scrollY = window.scrollY;
        document.body.style.position = "fixed";
        document.body.style.width = "100%";
      });
      this.observeMenuMobileClass();
    }
    if (this.closeMenu != null && this.closeMenu != "undefined") {
      this.closeMenu.addEventListener("click", () => {
        removeTrapFocusOnModal(
          ctx.menuMobile,
          ctx.trapFocusMobileFiltersHandler
        );
        ctx.closeFiltersModal(scrollY);
        ctx.triggerMenu.focus();
      });
    }
    if (this.applyCta != null && this.applyCta != "undefined") {
      this.applyCta.addEventListener("click", () => {
        ctx.closeFiltersModal(scrollY);
      });
    }

    if (this.menuMobile != null) {
      this.menuMobile.addEventListener("keydown", e => {
        if (e.key === "Escape") {
          ctx.closeFiltersModal(scrollY);
        }
      });
    }
  }

  closeFiltersModal(scrollY) {
    this.menuMobile.classList.remove(this.CLASSNAMES.open);
    if (this.triggerMenu) {
      this.triggerMenu.setAttribute("aria-expanded", "false");
      this.triggerMenu.focus();
    }
    document.body.style.position = "";
    window.scrollTo(0, scrollY);
  }

  listenSelected() {
    this.inputs.forEach(input => {
      input.addEventListener("change", () => {
        this.filterQuery(input, false);
      });
    });
  }

  listenSort() {
    this.sortBy.forEach(singleSort => {
      singleSort.addEventListener("change", e => {
        this.filterQuery(singleSort);
        const mobileInput = this.menuMobile.querySelector(
          "input[value=" + singleSort.value + "]"
        );
        if (mobileInput != null) {
          mobileInput.checked = true;
        }
      });
    });
  }

  restoreSortSelectionFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    let sortValue;
    const qParam = urlParams.get('q') || '';

    const match = qParam.match(/(price-(asc|desc)(-sale)?|new-arrival|topRated|personalization|rank)/);
    if (match) {
      sortValue = match[1];
    }

    if (sortValue) {
      this.sortBy.forEach(radio => {
        if (radio.name === 'sortBy') {
          radio.checked = radio.value === sortValue;
        }
      });
      if (this.menuMobile) {
        const mobileRadio = this.menuMobile.querySelector(
          `input[name="sortBy"][value="${sortValue}"]`
        );
        if (mobileRadio) mobileRadio.checked = true;
      }
    }
  }

  setActive() {
    let filterBar =
      typeof this.filterBar == "undefined" || this.filterBar == null
        ? document.querySelector(this.SELECTORS.filterBar)
        : this.filterBar;
    filterBar.classList.add(this.CLASSNAMES.active);
    let menuMobile =
      typeof this.menuMobile == "undefined" || this.menuMobile == null
        ? document.querySelector(this.SELECTORS.menuMobile)
        : this.menuMobile;
    if (menuMobile != null) {
      menuMobile.classList.add(this.CLASSNAMES.active);
    }
    let resetCta =
      typeof this.resetCta == "undefined" || this.resetCta == null
        ? document.querySelectorAll(this.SELECTORS.resetCta)
        : this.resetCta;
    resetCta.forEach(input => {
      input.disabled = false;
    });
    this.resetFilters();
  }

  setDisabled() {
    let filterBar =
      typeof this.filterBar == "undefined" || this.filterBar == null
        ? document.querySelector(this.SELECTORS.filterBar)
        : this.filterBar;
    if (filterBar != null && typeof filterBar !== "undefined") {
      filterBar.classList.remove(this.CLASSNAMES.active);
    }
    let menuMobile =
      typeof this.menuMobile == "undefined" || this.menuMobile == null
        ? document.querySelector(this.SELECTORS.menuMobile)
        : this.menuMobile;
    if (menuMobile != null && typeof menuMobile !== "undefined") {
      menuMobile.classList.remove(this.CLASSNAMES.active);
    }
    let resetCta =
      typeof this.resetCta == "undefined" || this.resetCta == null
        ? document.querySelectorAll(this.SELECTORS.resetCta)
        : this.resetCta;
    resetCta.forEach(input => {
      input.disabled = true;
    });
  }

  fixFilters() {
    let scroll =
      this.returnOffsetHeight(this.listingHead) +
      this.returnOffsetHeight(this.benefitBar) +
      1;
    if (
      this.filterBar.classList.contains("in-sale") &&
      this.filtersForm != null
    ) {
      scroll =
        scroll +
        document.querySelector(".w-sales__macro-category").offsetHeight +
        document.querySelector(".w-sales__micro-category").offsetHeight;
    }
    if (window.scrollY > scroll) {
      this.$component.style.position = "fixed";
      this.$component.classList.add(this.CLASSNAMES.fixed);
      if (this.listing) {
        this.listing.style.paddingTop = `${this.$component.offsetHeight}px`;
      }
    } else {
      this.$component.style.position = "";
      this.$component.classList.remove(this.CLASSNAMES.fixed);
      if (this.listing) {
        this.listing.style.paddingTop = 0;
      }
    }
  }

  setGridSmEvent(target) {
    this.gridSm.forEach(grid => {
      grid.classList.remove(this.CLASSNAMES.active);
    });
    target.classList.add(this.CLASSNAMES.active);
    let value = target.dataset.gridSm;
    this.listings.forEach(listing => {
      let valueMax = listing.dataset.gridMaxSm;
      let valueMaxMd = listing.dataset.gridMaxMd;
      let valueMinMd = listing.dataset.gridMinMd;
      if (value == valueMax) {
        addNewPageInHistory(addOrUpdateUrlParam("normal", true), "", "");
        this.setGridMd(listing, this.gridMd, valueMaxMd);
      } else {
        addNewPageInHistory(addOrUpdateUrlParam("normal", false), "", "");
        this.setGridMd(listing, this.gridMd, valueMinMd);
      }
      listing.dataset.gridSm = value;
    });
    if (this.productTwinText) {
      if (value == 1) {
        this.productTwinText.classList.remove(this.CLASSNAMES.pttWide);
      } else {
        this.productTwinText.classList.add(this.CLASSNAMES.pttWide);
      }
    }
  }

  setGridMdEvent(target) {
    this.gridMd.forEach(grid => {
      grid.classList.remove(this.CLASSNAMES.active);
      grid.setAttribute("aria-pressed", "false");
    });
    target.classList.add(this.CLASSNAMES.active);
    target.setAttribute("aria-pressed", "true");
    let value = target.dataset.gridMd;
    this.listings.forEach(listing => {
      let valueMax = listing.dataset.gridMaxMd;
      let valueMaxSm = listing.dataset.gridMaxSm;
      let valueMinSm = listing.dataset.gridMinSm;
      if (value == valueMax) {
        addNewPageInHistory(addOrUpdateUrlParam("normal", true), "", "");
        this.setGridSm(listing, this.gridSm, valueMaxSm);
      } else {
        addNewPageInHistory(addOrUpdateUrlParam("normal", false), "", "");
        this.setGridSm(listing, this.gridSm, valueMinSm);
      }
      listing.dataset.gridMd = value;
    });
    if (this.productTwinText) {
      if (value == 2) {
        this.productTwinText.classList.remove(this.CLASSNAMES.pttWide);
      } else {
        this.productTwinText.classList.add(this.CLASSNAMES.pttWide);
      }
    }
  }

  setGridSm(listing, grids, value) {
    grids.forEach(grid => {
      if (grid.dataset.gridSm == value) {
        grid.classList.add(this.CLASSNAMES.active);
      } else {
        grid.classList.remove(this.CLASSNAMES.active);
      }
    });
    listing.dataset.gridSm = value;
  }

  setGridMd(listing, grids, value) {
    grids.forEach(grid => {
      if (grid.dataset.gridMd == value) {
        grid.classList.add(this.CLASSNAMES.active);
      } else {
        grid.classList.remove(this.CLASSNAMES.active);
      }
    });
    listing.dataset.gridMd = value;
  }

  showAllShortcuts() {
    this.shortcutsCta.addEventListener("click", () => {
      this.shortcutsList.classList.add(this.CLASSNAMES.open);
    });
  }

  orderShortcuts() {
    const urlParams = new URLSearchParams(window.location.search);
    let categoryCode = urlParams.get("categoryCode");
    if (categoryCode != null) {
      let firstShortcut = this.shortcutsList.querySelector(
        '[data-cat="' + categoryCode + '"]'
      );
      if (firstShortcut) {
        let shortcuts = this.shortcutsList.querySelectorAll("[data-cat]"),
          i;
        for (i = 0; i < shortcuts.length; ++i) {
          shortcuts[i].classList.remove("active");
        }
        firstShortcut.classList.add("active");
      } else {
        let baseShortcut = this.shortcutsList
          .querySelector('[data-cat="0"]')
          .classList.add("active");
      }
    }
  }

  filterInputsRender(inputsArr) {
    let filtersAvailableArr = [];

    inputsArr.forEach(singleFilter => {
      filtersAvailableArr.push(singleFilter.id);
    });

    let inputs = document.querySelectorAll(this.SELECTORS.input);

    inputs.forEach(singleInput => {
      const filterLvl = singleInput.getAttribute("lvl");

      if (!filterLvl || filterLvl !== "1") {
        let mobileFilter = document.querySelector(
          "#" + singleInput.id + "-mobile"
        );

        if (
          filtersAvailableArr.includes(singleInput.id) ||
          singleInput.checked
        ) {
          singleInput.disabled = false;
          if (singleInput.nextElementSibling) {
            singleInput.nextElementSibling.setAttribute(
              "aria-disabled",
              "false"
            );
          }

          if (mobileFilter && mobileFilter !== null) {
            mobileFilter.disabled = false;
            if (mobileFilter.nextElementSibling) {
              mobileFilter.nextElementSibling.setAttribute(
                "aria-disabled",
                "false"
              );
            }
          }
        } else {
          singleInput.disabled = true;
          if (singleInput.nextElementSibling) {
            singleInput.nextElementSibling.setAttribute(
              "aria-disabled",
              "true"
            );
          }

          if (mobileFilter && mobileFilter !== null) {
            mobileFilter.disabled = true;
            if (mobileFilter.nextElementSibling) {
              mobileFilter.nextElementSibling.setAttribute(
                "aria-disabled",
                "true"
              );
            }
          }
        }
      }
    });
  }

  filterCounter() {
    let filter_count;
    let total = 0;
    this.filters.forEach(filter => {
      if (filter.classList.contains("sort")) return false;
      let input = filter.querySelectorAll("input[type=checkbox]:checked");
      if (input.length > 0) {
        filter.setAttribute("data-results", input.length);
        filter.classList.add("filtered");
        let id = filter.getAttribute("data-facet-code");
        if (typeof id != "undefined") {
          let mobileFilter = document.querySelector(
            "[data-facet-code-mobile=" + id + "]"
          );
          if (typeof mobileFilter !== "undefined") {
            let mobileFilterTitle = mobileFilter.querySelector(
              ".w-f__menu__filter__name"
            );
            mobileFilterTitle.setAttribute("data-results", input.length);
            mobileFilterTitle.classList.add("filtered");
          }
        }
        total = total + input.length;
      } else {
        filter.setAttribute("data-results", "");
        filter.classList.remove("filtered");
        let id = filter.getAttribute("data-facet-code");
        if (typeof id != "undefined") {
          let mobileFilter = document.querySelector(
            "[data-facet-code-mobile=" + id + "]"
          );
          if (typeof mobileFilter !== "undefined") {
            let mobileFilterTitle = mobileFilter.querySelector(
              ".w-f__menu__filter__name"
            );
            mobileFilterTitle.setAttribute("data-results", "");
            mobileFilterTitle.classList.remove("filtered");
          }
        }
      }
    });
    if (total > 0) {
      this.setActive();
    } else {
      this.setDisabled();
    }
    if (
      typeof this.menuMobileTitle !== "undefined" &&
      this.menuMobileTitle !== null
    )
      this.menuMobileTitle.setAttribute("data-results", total);
  }

  get QUERY_PARAMS() {
    return {
      base: () => {
        if (document.body.classList.contains("t-search")) {
          return "?partial=true&save=false";
        }
        return "?save=false";
      },
      sortBy: (qs = false) => {
        this.sortBy = document.querySelectorAll(this.SELECTORS.sortBy);
        if (typeof this.sortBy == "undefined" || this.sortBy == null) return;
        let sort = "topRated";
        this.sortBy.forEach(single_radio => {
          if (single_radio.checked === true) {
            sort = single_radio.value;
          }
        });
        if (this.pageSalesFilters != null) {
          return "";
        }
        return sort + ":";
      },
      pagination: page => {
        let paginationQueryBit = "";
        if (page) {
          paginationQueryBit = "&page=" + page;
        }
        return paginationQueryBit;
      },
      textSearch: () => {
        let q = "";
        if (this.qs.get("q") != null) {
          q = this.qs.get("q");
        } else if (this.qs.get("text") != null) {
          q = this.qs.get("text");
        }
        if (document.body.classList.contains("t-search")) {
          if (q != null) {
            let matchString = new RegExp("[^:]*", "");
            let search = q.match(matchString);
            return search[0];
          } else {
            return "";
          }
        }
        if (
          document.body.classList.contains("t-sales") ||
          this.pageSalesFilters != null
        ) {
          if (q != null) {
            return q;
          } else {
            return "";
          }
        }
        return "";
      },
      listingLayout: () => {
        let name = "";
        this.listings.forEach(listing => {
          let value = listing.dataset.gridMd;
          let valueMax = listing.dataset.gridMaxMd;
          if (value == valueMax) {
            name = "&normal=true";
          } else {
            name = "&normal=false";
          }
        });
        return name;
      }
    };
  }

  buildQuery(page = false) {
    const isSearch = document.body.classList.contains("t-search");

    const serialized = $(this.filtersForm).serializeArray();
    const filtered = serialized.filter(p => p.name !== "sortBy");
    const formInputs = filtered.map(p => `${p.name}:${p.value}`).join(":");

    const sortWithColon = this.QUERY_PARAMS.sortBy();
    const sortValue = sortWithColon ? sortWithColon.replace(/:$/, "") : "";

    const textToken = this.QUERY_PARAMS.textSearch();

    let qParam = "";

    if (isSearch) {
      const parts = [];
      if (textToken) parts.push(textToken);
      if (sortValue) parts.push(sortValue);
      if (formInputs) parts.push(formInputs);
      qParam = parts.join(":");
    } else {
      if (sortValue) {
        if (sortValue === "personalization") {
          qParam = `:${sortValue}`;
          if (formInputs) qParam += `:${formInputs}`;
        } else {
          if (textToken) {
            qParam = `${textToken}:${sortValue}`;
          } else {
            qParam = `:${sortValue}`;
          }
          if (formInputs) qParam += `:${formInputs}`;
          qParam += `:sortBy:${sortValue}`;
        }
      } else {
        if (textToken) {
          qParam = formInputs ? `${textToken}:${formInputs}` : textToken;
        } else {
          qParam = formInputs ? `:${formInputs}` : "";
        }
      }
    }

    qParam = qParam.replace(/:{2,}/g, ":").replace(/:$/, "");

    const fullQuery =
      this.QUERY_PARAMS.base() +
      this.QUERY_PARAMS.listingLayout() +
      "&isRefineSearch=true" +
      "&q=" +
      qParam +
      this.QUERY_PARAMS.pagination(page);

    this.log("fullQuery ", fullQuery);
    return fullQuery;
  }

  getFilteredPage(query) {
    return this.ajaxAction.getPage(query);
  }

  renderPage(res, target, query = false) {
    let response = new DOMParser().parseFromString(res, "text/html");
    this.ajaxAction.renderContent(res, "products");
    this.$emit(this.$customEvents.FILTERS_EVENTS.pageLoaded);
    this.$emit(this.$customEvents.FILTERS_EVENTS.updated, {
      response: response,
      res: res,
      query: query
    });
    this.trackNewProducts(response);
    window.scrollTo(0, 0);
  }

  filterQuery(input, page) {
    if ($(input).attr("data-sortby-name") !== undefined) {
      this.TrackingComponent.actions.filterTracking(input, true);
    } else {
      this.TrackingComponent.actions.filterTracking(input);
    }
    this.log("launch query");
    document.querySelector("body").classList.add("loading");
    let query = this.buildQuery(page);
    let productsContainer = this.productsContainer;
    this.getFilteredPage(`${query}`).then(res => {
      let newURL = query.replace("isRefineSearch=true", "isRefineSearch=false");
      if (this.body.classList.contains("t-salesV2-category")) {
        newURL = query;
      }
      this.renderPage(res, productsContainer, newURL);
      if (
        typeof input !== "undefined" &&
        this.menuMobile != null &&
        !this.menuMobile.classList.contains(this.CLASSNAMES.open)
      ) {
        this.mobileInput(input);
      }
    });
  }

  resetFilters() {
    this.resetCta.forEach(reset => {
      reset.addEventListener("click", () => {
        this.inputs.forEach(input => {
          input.checked = false;
        });
        this.mobileInputs.forEach(input => {
          input.checked = false;
        });
        this.filterQuery();
      });
    });
  }

  resetSearch() {
    if (this.resetSearchButton != null) {
      this.resetSearchButton.addEventListener("click", () => {
        if (this.listingSearchInput != null) {
          this.listingSearchInput.value = "";
        }
      });
    }
  }

  trackNewProducts(response) {
    let newProducts = null;
    const newProductsContainer = response.querySelector(
      '[data-ajax-source="products"]'
    );

    if (newProductsContainer != null) {
      newProducts = newProductsContainer.querySelectorAll(".c-product-card");
    }

    if (newProducts != null) {
      this.TrackingComponent.actions.loadMore(newProducts);
    }
  }

  onRadioSortByKeydown() {
    this.radioFilters.forEach(radio => {
      const span = radio.querySelector('[role="checkbox"]');
      const input = radio.querySelector('input[type="radio"]');
      if (span) {
        span.addEventListener("keydown", e => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            span.parentElement.parentElement
              .querySelectorAll('[role="checkbox"]')
              .forEach(siblingSpan => {
                siblingSpan.setAttribute("aria-checked", "false");
              });
            span.setAttribute("aria-checked", "true");
            input.click();
          }
        });
      }
    });
  }

  onFilterCheckboxLabelKeydown() {
    this.checkboxFilters.forEach(checkbox => {
      const label = checkbox.querySelector("label");
      const input = checkbox.querySelector('input[type="checkbox"]');
      if (label) {
        label.addEventListener("keydown", e => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            input.click();
          }
        });
      }
    });
  }

  trapFocusOnFilterDropdownEscape() {
    const ctx = this;
    this.dropdowns.forEach(dropdown => {
      dropdown.addEventListener("keydown", e => {
        if (e.key === "Escape") {
          e.preventDefault();
          const filter = dropdown.parentElement;
          ctx.closeDropdown(filter);
          filter.querySelector(".filter-dropdown-trigger").focus();
        }
      });
    });
  }

  ensureDefaultSortSelectedForSearch() {
    if (!document.body.classList.contains("t-search")) return;
    this.sortBy = document.querySelectorAll(this.SELECTORS.sortBy);
    if (!this.sortBy || this.sortBy.length === 0) return;
    let alreadyChecked = false;
    this.sortBy.forEach(r => {
      if (r.checked) alreadyChecked = true;
    });
    if (alreadyChecked) return;
    const fallback =
      Array.from(this.sortBy).find(r => r.value === "topRated") ||
      this.sortBy[0];
    if (fallback) {
      fallback.checked = true;
      if (this.menuMobile) {
        const mobileInput = this.menuMobile.querySelector(
          'input[type="radio"][value="' + fallback.value + '"]'
        );
        if (mobileInput) mobileInput.checked = true;
      }
    }
  }

  bindEvents() {
    $(window).bind("pageshow", event => {
      if (event.originalEvent.persisted) {
        let handleFocus, $focusElement;
        $focusElement = $(getFocusElement());
        handleFocus = hasFocusElement() && $focusElement.length > 0;
        if (handleFocus) {
          this.timedOutScrollToElement($focusElement);
        }
      }
    });

    $(document).ready(() => {
      let checkedInputsForm = document.querySelectorAll(
        ".filters-layer input[type=checkbox]:checked"
      );
      let $focusElement = $(getFocusElement());
      let handleFocus = hasFocusElement() && $focusElement.length > 0;
      let yourHeight =
        this.returnOffsetHeight(this.benefitBar) +
        this.returnOffsetHeight(this.listingHead) +
        this.returnOffsetHeight(this.pageSalesFilters) +
        this.returnOffsetHeight(this.filterWrapper);
      if (checkedInputsForm.length > 0) {
        this.filterCounter();
        this.setActive();
      }
      if (handleFocus) {
        this.timedOutScrollToElement($focusElement, yourHeight);
      }
    });

    this.$on(
      this.$customEvents.FILTERS_EVENTS.updated,
      ({ event, payload }) => {
        if (this.resultsCount != null)
          this.resultsCount.innerHTML = payload.response.querySelector(
            this.SELECTORS.resultsCounter
          ).innerHTML;

        let filtersAvailable = payload.response.querySelectorAll(
          'input[type="checkbox"]'
        );
        this.filterInputsRender(filtersAvailable);
        this.filterCounter();
        let newQs = payload.query.replace(this.QUERY_PARAMS.base() + "&", "?");
        history.replaceState(null, null, newQs);
        document.querySelector("body").classList.remove("loading");
      }
    );

    this.onFilterCheckboxLabelKeydown();
    this.onRadioSortByKeydown();
    this.trapFocusOnFilterDropdownEscape();
  }

  timedOutScrollToElement($element, yourHeight) {
    setTimeout(() => {
      this.scrollToElement($element);
    }, 500);
  }

  scrollToElement($element, yourHeight) {
    $element.get(0).scrollIntoView({
      block: "center",
      inline: "nearest",
      behavior: "smooth"
    });
  }

  returnOffsetHeight(element) {
    let offsetHeightVal = 0;
    if (element != null) {
      offsetHeightVal = element.offsetHeight;
    }
    return offsetHeightVal;
  }

  render() {
    this.log("Rendering...");
    this.listenScroll();
    this.listenDropdown();
    this.listenModal();
    this.listenGrid();
    this.listenSelected();
    if (this.shortcutsCta && this.shortcutsList) {
      this.orderShortcuts();
      this.showAllShortcuts();
    }
    this.listenSort();
    this.ensureDefaultSortSelectedForSearch();
    this.bindEvents();
    this.mobileHandling();
    this.resetSearch();
    this.restoreSortSelectionFromUrl();
  }

  mobileHandling() {
    if (this.menuMobile == null) return false;
    let inputs = this.menuMobile.querySelectorAll("input[type=checkbox]");
    inputs.forEach(input => {
      input.addEventListener("change", () => {
        if (this.menuMobile.classList.contains(this.CLASSNAMES.open)) {
          let id = input.id;
          let new_id = id.replace("-mobile", "");
          let desktop_input = document.querySelector("#" + new_id);
          desktop_input.click();
        }
      });
    });
    let sortRadio = this.menuMobile.querySelectorAll("input[type=radio]");
    sortRadio.forEach(sortRadio => {
      sortRadio.addEventListener("change", () => {
        this.filterBar
          .querySelector("input[value=" + sortRadio.value + "]")
          .click();
      });
    });
  }

  mobileInput(input) {
    let id = input.id;
    if (
      typeof id == "undefined" ||
      $(input).attr("data-sortby-name") !== "undefined"
    )
      return false;
    let mobile_id = id + "-mobile";
    let mobile_input = document.querySelector("#" + mobile_id);
    mobile_input.checked = input.checked;
  }
}
